module.exports = __webpack_public_path__ + "img/3.989d6b88.png";